import {
  CampaignProductsStatisticsState,
  REQUEST_CAMPAIGNCOMPARISON_PRODUCTSTATISTICS,
  REQUEST_CAMPAIGNCOMPARISON_PRODUCTSTATISTICS_DONE,
  REQUEST_CAMPAIGNPRODUCTSTATISTICS,
  REQUEST_CAMPAIGNPRODUCTSTATISTICS_DONE
} from "./types";

const initialState: CampaignProductsStatisticsState = {
  isLoading: true,
  isLoadingCompare: true,
  campaignProductsStatistics: [],
  campaignComparisonProductStatistics: []
};

export function reducer(state = initialState, action: any) {
  switch (action.type) {
    case REQUEST_CAMPAIGNPRODUCTSTATISTICS:
      return {
        isLoading: true,
        isLoadingCompare: state.isLoadingCompare,
        campaignProductsStatistics: action.payload,
        campaignComparisonProductStatistics:
          state.campaignComparisonProductStatistics
      };
    case REQUEST_CAMPAIGNPRODUCTSTATISTICS_DONE:
      return {
        isLoading: false,
        isLoadingCompare: state.isLoadingCompare,
        campaignProductsStatistics: action.payload,
        campaignComparisonProductStatistics:
          state.campaignComparisonProductStatistics
      };
    case REQUEST_CAMPAIGNCOMPARISON_PRODUCTSTATISTICS:
      return {
        isLoading: state.isLoading,
        isLoadingCompare: true,
        campaignProductsStatistics: state.campaignProductsStatistics,
        campaignComparisonProductStatistics: action.payload
      };
    case REQUEST_CAMPAIGNCOMPARISON_PRODUCTSTATISTICS_DONE:
      return {
        isLoading: state.isLoading,
        isLoadingCompare: false,
        campaignProductsStatistics: state.campaignProductsStatistics,
        campaignComparisonProductStatistics: action.payload
      };
    default:
      return state;
  }
}
